export default __webpack_public_path__ + "static/media/feedback.0aa4402c.svg";